import { filterCompaniesFromUserType } from "./filterUtil";

/**
 * Resolves the company uniqueId (e.g. "CID1057" or "CID1059") from user type organizations.
 * Automatically filters out non-companies and selects the latest active record.
 *
 * @param {Array|Object} userTypeData - Redux onboarding.userTypeDetails data
 * @param {string} companyName - The target company name to match
 * @returns {string|null} - The company uniqueId (e.g. "CID1057") or null
 */
export const getCompanyIdFromUserType = (userTypeData, companyName) => {
  if (!userTypeData || !companyName) return null;

  const companies = filterCompaniesFromUserType(userTypeData);
  if (!companies || companies.length === 0) return null;

  const searchTarget = String(companyName).trim().toLowerCase();

  const matched = companies.find((comp) => {
    const compName = (comp?.companyName || comp?.company_name || "")?.trim()?.toLowerCase();
    const cid = (comp?.cid || comp?.uniqueId || "")?.toString()?.trim()?.toLowerCase();

    return compName === searchTarget || cid === searchTarget;
  });

  if (matched?.cid) {
    return matched.cid;
  }

  if (companies.length === 1 && companies[0]?.cid) {
    return companies[0].cid;
  }

  return null;
};

/**
 * Resolves the numeric company entityId (e.g. 515) from user type organizations
 * matching either by company name or uniqueId/cid.
 *
 * @param {Array|Object} userTypeData - Redux onboarding.userTypeDetails data
 * @param {string|number} companyNameOrCid - Company name or CID string/number to match
 * @returns {number|null} - The company numeric entityId or null
 */
export const getEnterpriseEntityIdFromUserType = (userTypeData, companyNameOrCid) => {
  if (!userTypeData || !companyNameOrCid) return null;

  const companies = filterCompaniesFromUserType(userTypeData);
  if (!companies || companies.length === 0) return null;

  const searchTarget = String(companyNameOrCid).trim().toLowerCase();

  const matched = companies.find((comp) => {
    const compName = (comp?.companyName || comp?.company_name || "")?.trim()?.toLowerCase();
    const cid = (comp?.cid || comp?.uniqueId || "")?.toString()?.trim()?.toLowerCase();
    const id = (comp?.id || comp?.entityId || "")?.toString()?.trim()?.toLowerCase();

    return compName === searchTarget || cid === searchTarget || id === searchTarget;
  });

  if (matched?.id) {
    return Number(matched.id);
  }

  // Fallback: If only 1 company exists, return its id
  if (companies.length === 1 && companies[0]?.id) {
    return Number(companies[0].id);
  }

  return null;
};

export {
  filterCompaniesFromUserType,
  filterCompanyUtil,
  filterOldCompanies,
  formatCompanyResponse,
} from "./filterUtil";



